'use client';

import {
  type BaseImageStatus,
  createImageProcessingContext,
} from '@/components/batchToolsComp/layoutContext/ImageProcessingContext';
import { type BGColorEnum } from '../processing/components/BgColorSelector';

export type ImageStatus = BaseImageStatus & {
  finalStatus: 'ready' | 'processing' | 'success' | 'failed' | 'timeout';
  showImgState: 'Original' | 'Preview';

  // TODO 批量去背景色上色预览和下载
  showImgBgColor: BGColorEnum;
};

// 使用工厂创建图像修复的Context
const { Provider: ImageProcessingProvider, useImageProcessing } =
  createImageProcessingContext<ImageStatus>();

// 导出水印移除的Context组件和Hook
export { ImageProcessingProvider, useImageProcessing };
